import React from 'react'

import MailchimpSubscribeForm from './MailchimpSubscribeForm.jsx'

function Legal(props) {

  const featuredImage = 'https://discover.af-pictures.com/storage/app/uploads/public/c23/4f8/aee/thumb__1300_700_0_0_crop.jpg';



  return (
<>

    <div style={{ backgroundImage: 'url(' + featuredImage + ')',backgroundPosition:'center', backgroundSize:'cover'}} className="relative background-cover items-center h-[40vh]">
      <h1 style={{fontSize:'200%'}} className="text-center w-full pt-[20vh]  font-semibold">ÚNETE AL CLUB AF</h1>
  </div>
    <div className={"flex flex-col justify-between  pl-0 md:pl-10" + props.transition}>


  <div className="pt-8 mb-16 lg:mb-0 lg:pt-32 lg:pr-5 text-gray-900">
    <p class="max-w-[640px] mx-auto p-4 text-xl md:text-2xl">
      Únete a nuestro club para recibir invitaciones a preestrenos y pases tests, recibir regalos promocionales, estar informado de nuestros próximos lanzamientos, participar en sorteos <br/>¡y mucho más!
    </p>
    <MailchimpSubscribeForm/>

  </div>

</div>
</>
  )
}

export default Legal
